<template>
  <v-layout row fill-height align-center justify-center wrap>
    <v-flex shrink>
      <v-layout column align-center justify-center>
        <div class="warning-message">
          Page Under Construction
        </div>

        <v-btn to="/hub" text color="accent" style="text-transform: none">
          Return to Hub
        </v-btn>
      </v-layout>
    </v-flex>

    <v-flex shrink>
      <v-layout align-center justify-center>
        <lottie-player
          src="https://assets9.lottiefiles.com/packages/lf20_AQcLsD.json"
          background="transparent"
          speed="1"
          style="width: 400px; height: 400px;"
          loop
          autoplay
        />
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "PageUnderConstruction"
};
</script>

<style scoped>
.warning-message {
  color: black;
  font-size: 50px;
  font-weight: 900;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/PageUnderConstruction.vue